import type { FeatureModule } from '@store/features/types';

export const jotSupportFeature: FeatureModule = {
  id: 'jotSupport',
  name: 'Jot support',
  reducers: {},
  middleware: [],
};
